<template>
  <div
    class="px-20 pt-10"
  >
    <InsightsUnusualActivityWidgetHighlightsTable
      :loading="isLoading"
      :sort-options="sortOptions"
      :time-zone="timeZone"
      :widget-data="data"
      @sort="sort"
    />
    <div class="text-align-right pb-20 pr-20">
      <a
        v-track:click="{ label: 'Unusual widget view selected', selected: 'View all' }"
        class="strong"
        :href="linkToUnusualActivity"
      >
        View all
      </a>
    </div>
  </div>
</template>

<script>
import { INSIGHTS } from '~/app_constants';
import { Insights, InsightsFilters } from '~/mixins';
import { mapGetters } from 'vuex';

import InsightsUnusualActivityWidgetHighlightsTable from '~/components/insights/InsightsUnusualActivityWidgetHighlightsTable.vue';

export default {
  name: 'InsightsUnusualActivityWidgetHighlights',
  components: {
    InsightsUnusualActivityWidgetHighlightsTable,
  },
  mixins: [Insights, InsightsFilters],
  props: {
    data: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    sort: {
      type: Function,
      required: true,
    },
    sortOptions: {
      type: Object,
      required: true,
    },
    timeZone: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    limit: INSIGHTS.parameters.unusualActivityLimit,
  }),
  computed: {
    ...mapGetters(['isUserDashboard']),
    userId() {
      return this.filters?.user_id;
    },
    teamId() {
      return this.filters?.team_id;
    },
    linkToUnusualActivity() {
      const url = new URL(window.location.href);

      url.searchParams.set('tab', 'unusual-activity');

      return url.toString();
    },
  },
  methods: {
    switchMember(id) {
      const string = `${id}_user_id`;

      this.setPreviousView({ previousView: this.selectedFilter, currentView: string });
      this.setSelectedFilter(string);
      this.setMembersFilter(string);
    },
  },
};
</script>
